import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../services/AuthService';

import uniLogo from './../../images/uniempleo-logo-nuevo.png';
import loginbg from '../../images/portada-uniempleo.png';

export function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setEmailError('');

        if (!email.trim()) {
            setEmailError('El correo electrónico es requerido');
            return;
        }

        setLoading(true);
        try {
            await forgotPassword(email.trim());
        } catch (_err) {
            // La API siempre devuelve 200; si hay error de red mostramos el mismo
            // mensaje genérico para no revelar información.
        } finally {
            setLoading(false);
            setSubmitted(true);
        }
    }

    return (
        <div className="page-wraper" style={{ height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
            <div className="page-content bg-white login-style2" style={{ height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
                <div
                    className="dez-bnr-inr dez-bnr-inr-md overlay-black-middle"
                    style={{ backgroundImage: `url(${loginbg})`, height: '100vh', margin: 0, padding: 0 }}
                >
                    <div className="section-full" style={{ height: '100vh', margin: 0, padding: 0 }}>
                        <div className="container-fluid p-a0" style={{ height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
                            <div className="row" style={{ height: '100vh', margin: 0, padding: 0 }}>
                                <div className="col-lg-4 col-md-4 col-sm-12 p-a0" style={{ height: '100vh', overflow: 'hidden' }}>
                                    <div
                                        className="submit-resume p-a40 seth bg-white"
                                        style={{
                                            height: '100vh',
                                            borderRadius: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        <div className="nav">
                                            <div className="logo m-b30">
                                                <Link to="/"><img src={uniLogo} alt="UNIEMPLEO" style={{ maxWidth: '180px' }} /></Link>
                                            </div>

                                            <div className="col-12 p-a0">
                                                <h3 className="m-b20" style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333' }}>
                                                    Recuperar Contraseña
                                                </h3>
                                                <p className="font-weight-600 m-b30" style={{ color: '#666', fontSize: '0.95rem' }}>
                                                    Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
                                                </p>

                                                {submitted ? (
                                                    <div
                                                        style={{
                                                            backgroundColor: '#d4edda',
                                                            color: '#155724',
                                                            border: '1px solid #c3e6cb',
                                                            borderRadius: '4px',
                                                            padding: '15px',
                                                            marginBottom: '20px',
                                                        }}
                                                    >
                                                        <i className="fa fa-check-circle" style={{ marginRight: '8px' }}></i>
                                                        Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.
                                                        Revisa también tu carpeta de spam.
                                                    </div>
                                                ) : (
                                                    <form onSubmit={handleSubmit} className="col-12 p-a0" noValidate>
                                                        <div className="form-group m-b20">
                                                            <label
                                                                className="font-weight-600"
                                                                htmlFor="fp-email"
                                                                style={{ marginBottom: '8px', display: 'block' }}
                                                            >
                                                                Correo Electrónico *
                                                            </label>
                                                            <div className="input-group">
                                                                <input
                                                                    id="fp-email"
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="correo@ejemplo.com"
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    style={{ padding: '12px 15px' }}
                                                                    autoComplete="email"
                                                                />
                                                            </div>
                                                            {emailError && (
                                                                <div className="text-danger fs-12 mt-1">{emailError}</div>
                                                            )}
                                                        </div>

                                                        <div className="m-t30">
                                                            <button
                                                                type="submit"
                                                                className="site-button btn-block"
                                                                style={{
                                                                    backgroundColor: loading ? '#cccccc' : '#009247',
                                                                    borderColor: loading ? '#cccccc' : '#009247',
                                                                    padding: '12px',
                                                                    fontSize: '1rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '15px',
                                                                    cursor: loading ? 'not-allowed' : 'pointer',
                                                                    opacity: loading ? 0.6 : 1,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '10px',
                                                                }}
                                                                disabled={loading}
                                                            >
                                                                {loading ? (
                                                                    <>
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                        <span>Enviando...</span>
                                                                    </>
                                                                ) : (
                                                                    'Enviar enlace de recuperación'
                                                                )}
                                                            </button>
                                                        </div>
                                                    </form>
                                                )}

                                                <div className="text-center" style={{ marginTop: '20px' }}>
                                                    <Link
                                                        to="/login"
                                                        style={{ color: '#00004C', fontSize: '13px', fontWeight: '600', textDecoration: 'none' }}
                                                    >
                                                        ← Volver al inicio de sesión
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="bottom-footer clearfix row text-center"
                                            style={{ padding: '0px 0 8px', marginTop: '20px', borderTop: '1px solid #e9ecef' }}
                                        >
                                            <div className="col-lg-12 text-center">
                                                <span style={{ fontSize: '11px', color: '#999' }}>
                                                    © {new Date().getFullYear()} UNIEMPLEO - Universidad del Caribe. Todos los derechos reservados.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
